import clsx from 'clsx'
import { ComponentProps, ReactNode } from 'react'

export function ApplicationHeader({ className, ...props }: ComponentProps<'header'>) {
  return <header role="banner" className={clsx(className, 'w-full')} {...props} />
}

export function ApplicationLayout({ header, children }: { header?: ReactNode; children?: ReactNode }) {
  return (
    <div
      className={clsx([
        // Basic layout
        'flex h-full w-full flex-col',

        // Background color
        'bg-white',

        // Dark mode
        'dark:bg-zinc-950'
      ])}
    >
      <div
        className={clsx([
          // Border
          'border-b border-zinc-950/10 dark:border-white/10',

          // Backdrop
          'backdrop-blur-sm dark:backdrop-blur',

          // Background
          'bg-white/7.5 dark:bg-zinc-900/7.5'
        ])}
      >
        {header}
      </div>
      <div className="h-0 flex-grow overflow-hidden">{children}</div>
    </div>
  )
}
